import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { POST_DELETE_VALID_CEQ_TEST_DATES_URL } from '../../constants/apiUrls';

// =============================================================================
// Request & Response Model
// =============================================================================
export interface DeleteValidCeqTestDateModelRequest {
  registrationExamLevelUuid: string;
  validCeqTestDateUuid: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError) => void;
}

export const usePostDeleteValidCeqTestDates = ({ onSuccess, onError }: Input) => {
  const deleteValidCeqTestDates = async (payload: DeleteValidCeqTestDateModelRequest) => {
    const res = await axiosClient.put<void>(
      POST_DELETE_VALID_CEQ_TEST_DATES_URL(payload.validCeqTestDateUuid),
      payload
    );
    return res.data;
  };

  return useCustomMutation(deleteValidCeqTestDates, {
    onSuccess,
    onError,
  });
};
